<template>
  <div class="has-background-white">
    <br />
    <br />
    <div class="container" style="padding: 1rem;">
      <h3 class="is-size-4 has-text-primary">
        {{ data.sampleTitle }}
      </h3>
      <div class="columns is-multiline center-columns">
        <div
          class="column is-3 has-text-centered has-text-darker"
          v-for="(item, i) in data.sample"
          :key="i"
        >
          <i
            :class="`fa-solid fa-3x ${item.icon} has-text-primary`"
            style="margin: 0.8rem"
          ></i>
          <p>
            {{ item.txt }}
          </p>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: "Sample",
  props: ["data"],
  data() {
    return {
      title: "Sample",
    };
  },
};
</script>
